import React, { Component } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { toastr } from 'react-redux-toastr';
import get from 'lodash/get';
import moment from 'moment';
import diff from 'object-diff';
import { connect } from 'react-redux';
import { connectModal } from 'redux-modal';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setLoader, removeLoader } from '../../../actions';
import { AdvertiserApi } from '../../../api';
import { convertDollarsToMills } from '../../../utils/helpers/currency';
import {
  InputField,
  DateField,
  required,
  SelectField,
  url,
  hasReference,
  parseDecimal,
  minValue,
} from '../../form';

class AdsForm extends Component {
  componentDidMount() {
    this.fetchCategories();
  }

  onFormSubmit(values) {
    const { dispatch, formAction, handleHide, account, selfServeCampaignId, ads, initialValues } = this.props;
    const data = initialValues ? diff(initialValues, values) : values;

    if (data.bid) {
      data.bid = parseInt(convertDollarsToMills(data.bid), 10);
    }
    data.referencenumber = hasReference(values.referencenumber);

    dispatch(setLoader('AdForm'));
    if (formAction === 'Update') {
      const args = {
        ...data,
        referencenumber: values.referencenumber,
        account_id: account.uuid,
        campaign_id: selfServeCampaignId,
      };
      dispatch(AdvertiserApi.actions.adUpdate.patch(values.id, args, (_error, success) => {
        dispatch(removeLoader('AdForm'));

        if (success) {
          const collection = [...ads.data].map((obj) => {
            return obj.uuid === success.data.uuid ? success.data : obj;
          });

          dispatch({
            type: AdvertiserApi.events.ads.actionSuccess,
            syncing: false,
            data: { ...ads, data: collection, meta: { ...ads.meta } }
          });
          toastr.success('Ad successfully updated!');
          handleHide();
        }
      }));
    }

    if (formAction === 'Create') {
      const args = {
        account_id: account.uuid,
        campaign_id: selfServeCampaignId,
        ad_format: 'text',
        ...data
      };
      dispatch(AdvertiserApi.actions.adCreate.post(args, (_error, success) => {
        dispatch(removeLoader('AdForm'));
        if (success) {
          const collection = [success.data, ...ads.data];
          dispatch({
            type: AdvertiserApi.events.ads.actionSuccess,
            syncing: false,
            data: { ...ads, data: collection, meta: { ...ads.meta } }
          });
          toastr.success('Ad successfully created!');
          handleHide();
        }
      }));
    }
  }

  fetchCategories() {
    const { categories, dispatch, account } = this.props;
    const data = { account_id: account.uuid };

    if (categories.length === 0) {
      dispatch(AdvertiserApi.actions.jobs.get(data));
    }    
  }

  render() {
    const { show, handleHide, heading, handleSubmit, isLoading, formAction, categories } = this.props;
    return (
      <Modal show={show}>
        <Modal.Header>
          <Modal.Title>{heading}</Modal.Title>
        </Modal.Header>
        <form
          onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
          className='m-t'
        >
          <Modal.Body>
            <Row>
              <Col md={12}>
                <Field
                  name="title"
                  label="Title"
                  component={InputField}
                  type="text"
                  placeholder="Title of the ad"
                  validate={required}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Field
                  name="referencenumber"
                  label="Reference Number"
                  component={InputField}
                  type="text"
                  placeholder="A unique number given to the ad to be used as reference"
                  disabled={formAction === 'Update'}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Field
                  name="company"
                  label="Company"
                  component={InputField}
                  type="text"
                  placeholder="Company of the ad"
                  validate={required}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Field
                  name="description"
                  label="Description"
                  component={InputField}
                  textarea
                  type="text"
                  placeholder="Description of the ad"
                  validate={required}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Field
                  name="category"
                  label="Category"
                  component={SelectField}
                  type="text"
                  creatable
                  options={categories}
                  format={e => { return e ? { label: e, value: e } : ''; }}
                  placeholder="eg. IT or Banking"
                  validate={required}
                  normalize={(e) => { return e ? e.value : ''; }}
                />
              </Col>
              <Col md={6}>
                <Field
                  type='number'
                  name='bid'
                  placeholder='Please enter the cost per click in ($)'
                  label='Bid($)'
                  component={InputField}
                  validate={[required, minValue(0.01)]}
                  parse={(value) => parseDecimal(value)}
                />
              </Col>
            </Row>           
            <Row>
              <Col md={12}>
                <Field
                  name="url"
                  label="URL"
                  component={InputField}
                  type="text"
                  placeholder="URL of the career page the ad should link to"
                  validate={[required, url]}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Field
                  name="location"
                  label="Location"
                  component={InputField}
                  type="text"
                  placeholder="Location of the place of work"
                  validate={[required]}
                />
              </Col>
            </Row>
            {formAction === 'Create' && (
              <Row>
                <Col md={12}>
                  <Field
                    type='date'
                    name='date'
                    placeholder='Please select when the ad was posted'
                    label='Post Date'
                    component={DateField}
                    validate={[required]}
                    maxDate={moment().startOf('day').toISOString()}
                    placement='top'
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col md={12}>
                <span style={{ textAlign: 'center', color: 'gray', marginTop: '15px' }}>
                  <div className='alert alert-warning'>
                    <FontAwesomeIcon icon="info-circle" />&nbsp;
                    Ads {formAction.toLowerCase()}d here will only be represented in this campaign and not your "Job Inventory"
                  </div>
                </span>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={handleHide}>Close</Button>
            <Button
              type='submit'
              loading={isLoading}
              bsStyle='primary'
            >
              {formAction || 'Submit'}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'AdForm'
});

const ResourceModal = connectModal({
  name: 'AdFormModal'
});

const mapStateToProps = (state) => {
  const { loader, advertiser: { jobs: { data: jobs } } } = state;
  const categories = get(jobs, 'meta.categories', []).map(c => {
    return { label: c, value: c };
  });
  const ads = get(state, 'advertiser.ads.data', {});
  const isLoading = loader.includes('AdForm');

  return {
    isLoading,
    ads,
    jobs,
    categories
  };
};

export default connect(mapStateToProps)(ResourceModal(ResourceForm(AdsForm)));
